// HC Variant Thumbnails -> switch product-card image by showing the matching slideshow-slide
// Works with Horizon-like markup where slides have: <slideshow-slide ... slide-id="MEDIA_ID" ...>

(function () {
  function getCard(el) {
    return el.closest('product-card');
  }

  function getMainSlides(card) {
    // target the gallery slideshow inside the product card (not the big carousels)
    // Most Horizon cards have a slideshow-component inside the gallery block.
    return card ? card.querySelector('slideshow-slides[ref="scroller"]') : null;
  }

  function getVisibleSlide(slidesEl) {
    if (!slidesEl) return null;
    // A visible slide often has aria-hidden="false" or no [hidden]
    return (
      slidesEl.querySelector('slideshow-slide[aria-hidden="false"]') ||
      slidesEl.querySelector('slideshow-slide:not([hidden])')
    );
  }

  function showSlideByMediaId(card, mediaId) {
    const slidesEl = getMainSlides(card);
    if (!slidesEl) return;

    const all = slidesEl.querySelectorAll('slideshow-slide');
    if (!all.length) return;

    // store initial visible slide once
    if (!card.dataset.hcInitialSlide) {
      const current = getVisibleSlide(slidesEl);
      if (current && current.getAttribute('slide-id')) {
        card.dataset.hcInitialSlide = current.getAttribute('slide-id');
      }
    }

    const target = slidesEl.querySelector(`slideshow-slide[slide-id="${mediaId}"]`);
    if (!target) return;

    all.forEach((s) => {
      // Keep non-variant slides behavior intact, only toggle among available slides
      s.setAttribute('aria-hidden', 'true');
      s.setAttribute('hidden', '');
    });

    target.removeAttribute('hidden');
    target.setAttribute('aria-hidden', 'false');
  }

  function restoreInitial(card) {
    const initial = card?.dataset?.hcInitialSlide;
    if (!initial) return;
    showSlideByMediaId(card, initial);
  }

  // hover + click on thumbnail
  document.addEventListener('mouseenter', function (e) {
    const btn = e.target.closest('.hc-variant-thumb');
    if (!btn) return;
    const card = getCard(btn);
    if (!card) return;

    const mediaId = btn.dataset.mediaId;
    if (mediaId) {
      showSlideByMediaId(card, mediaId);
      // active UI
      card.querySelectorAll('.hc-variant-thumb').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    }
  }, true);

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.hc-variant-thumb');
    if (!btn) return;

    const card = getCard(btn);
    if (!card) return;

    const mediaId = btn.dataset.mediaId;
    if (mediaId) {
      e.preventDefault();
      showSlideByMediaId(card, mediaId);
      card.querySelectorAll('.hc-variant-thumb').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    }
  });

  // when leaving the thumbs area, restore initial image (optional)
  document.addEventListener('mouseleave', function (e) {
    const thumbs = e.target.closest('.hc-variant-thumbs');
    if (!thumbs) return;
    const card = getCard(thumbs);
    if (!card) return;

    // remove active state
    card.querySelectorAll('.hc-variant-thumb').forEach(b => b.classList.remove('is-active'));
    restoreInitial(card);
  }, true);
})();